module.exports = __webpack_public_path__ + "static/media/LINA-BUSD.088dad94.svg";